import { useMutation } from '@tanstack/react-query';

import { loginApi } from '../api';

export default function useLoginMutation(config?: any) {
  return useMutation(loginApi, config);
}
